import * as bootstrap from 'bootstrap';
// import { Tab } from 'bootstrap';
import { Collapse } from 'bootstrap';

import jQuery from 'jquery';

// Import Swiper and modules styles
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import GSAP and ScrollTrigger
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

// Import Lenis for Smooth Scroll
import Lenis from 'lenis';

// Mega Menu tweaks
function init_mega_menu() {
    jQuery(function ($) {
        $('.nav-item.dropdown.has-mega-menu').hover(
            function () {
                if (window.matchMedia("(min-width: 992px)").matches) {
                    $(this).addClass('mega-menu-open');
                    var megaMenu = $(this).find('.mega-menu').first();
                    megaMenu.stop(true, true).delay(100).fadeIn(100, function () {
                        $(this).addClass('show');
                    });
                }
            },
            function () {
                if (window.matchMedia("(min-width: 992px)").matches) {
                    var megaMenu = $(this).find('.mega-menu').first();
                    megaMenu.stop(true, true).delay(400).fadeOut(100, function () {
                        $(this).removeClass('show');
                    });
                    $(this).removeClass('mega-menu-open');
                }
            }
        );

        $('.nav-link.dropdown-toggle.mega-menu-dropdown').on("click", function (e) {
            e.stopPropagation();

            var parentListItem = $(this).closest('.nav-item.dropdown.has-mega-menu');
            if (window.matchMedia("(max-width: 991px)").matches) {
                parentListItem.toggleClass('mega-menu-open');
                var megaMenu = parentListItem.find('.mega-menu').first();
                if (megaMenu.hasClass('show')) {
                    megaMenu.hide().removeClass('show');
                } else {
                    megaMenu.show().addClass('show');
                }
            }
        });

        $('.mega-menu').on("click", function (e) {
            e.stopPropagation();
        });
    });
}

// Swiper sliders

function initSwipers() {
    // Select all Swiper containers within .block_sl002 and initialize Swiper for each
    document.querySelectorAll('.block_sl002 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Navigation, Pagination],
            direction: "horizontal",
            loop: false,
            centeredSlides: true,
            speed: 800,
            slidesPerView: "auto",
            spaceBetween: 50,
            threshold: 5,
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    });

    // Select all Swiper containers within .block_sl003 and initialize Swiper for each
    document.querySelectorAll('.block_sl003 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: true,
            centeredSlides: true,
            speed: 5000,
            slidesPerView: 4,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
            },
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl004 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Navigation, Pagination],
            direction: "horizontal",
            loop: true,
            centeredSlides: false,
            speed: 1500,
            slidesPerView: 1.3,
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                resize: function () {
                    this.update();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl004 .swiper-container-about').forEach(function (container) {
        new Swiper(container, {
            modules: [Navigation, Pagination],
            direction: "horizontal",
            loop: true,
            centeredSlides: false,
            speed: 1500,
            slidesPerView: 1.1,
            spaceBetween: 100,
            threshold: 5,
            allowTouchMove: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                resize: function () {
                    this.update();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl004 .swiper-container-clients').forEach(function (container) {
        new Swiper(container, {
            modules: [Navigation, Pagination],
            direction: "horizontal",
            loop: true,
            centeredSlides: false,
            speed: 1500,
            slidesPerView: 1.2,
            spaceBetween: 100,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                },
                767: {
                    slidesPerView: 1.2,
                    spaceBetween: 100,
                    centeredSlides: false,
                },
            },
            threshold: 5,
            allowTouchMove: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                resize: function () {
                    this.update();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl005 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: true,
            centeredSlides: false,
            speed: 5000,
            slidesPerView: 4.5,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
            },
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl008 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: false,
            yoyo: true,
            duration: 4000,
            centeredSlides: true,
            speed: 3000,
            slidesPerView: 1.2,
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl009 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: true,
            duration: 1000,
            centeredSlides: true,
            speed: 3000,
            slidesPerView: 3,
            spaceBetween: 30,
            threshold: 5,
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                }
            },
            autoplay: {
                delay: 1000,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl010 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: false,
            yoyo: true,
            duration: 1000,
            centeredSlides: true,
            speed: 3000,
            slidesPerView: 3,
            spaceBetween: 20,
            threshold: 5,
            allowTouchMove: true,
            autoplay: {
                delay: 1000,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl011 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: false,
            yoyo: true,
            duration: 5000,
            centeredSlides: true,
            speed: 3000,
            slidesPerView: 1,
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl014 .swiper-container').forEach(function (container) {
        var swiper = new Swiper(container, {
            modules: [Navigation, Pagination],
            direction: "vertical",
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 10,
            allowTouchMove: false,
            mousewheel: {
                sensitivity: 5,
            },
            mousewheelControl: true,
            pagination: {
                el: ".swiper-pagination",
            },

        });

        ScrollTrigger.create({
            trigger: container,
            start: "top top",
            end: () => `+=${container.clientHeight * (swiper.slides.length - 1) * 0.5}`,
            pin: true,
            scrub: true,
            onUpdate: (self) => {
                const progress = self.progress * (swiper.slides.length - 1);
                swiper.slideTo(Math.round(progress));
            }
        });
    });

    document.querySelectorAll('.block_sl015 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: true,
            centeredSlides: true,
            speed: 10000,
            slidesPerView: 2.5,
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: true,
            grabCursor: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                }
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: true,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl017 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "horizontal",
            loop: true,
            centeredSlides: true,
            speed: 5000,
            slidesPerView: 8,
            breakpoints: {
                0: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                576: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 5,
                    spaceBetween: 50,
                },
                992: {
                    slidesPerView: 8,
                    spaceBetween: 50,
                },
            },
            spaceBetween: 50,
            threshold: 5,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });

    document.querySelectorAll('.block_sl018 .swiper-container').forEach(function (container) {
        new Swiper(container, {
            modules: [Autoplay],
            direction: "vertical",
            loop: true,
            centeredSlides: true,
            speed: 5000,
            slidesPerView: 1.2,
            spaceBetween: 0,
            threshold: 10,
            allowTouchMove: false,
            mousewheel: {
                sensitivity: 5,
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            mousewheelControl: false,
            on: {
                resize: function () {
                    this.update();
                    this.autoplay.start();
                },
            },
        });
    });
}

function initSmoothScrollLenis() {
    const lenis = new Lenis()

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
}

// GSAP Animations

// Animated Block Headings

function scroll_heading_animation() {

    document.querySelectorAll('.block_animated_text').forEach(block_animated_text => {

        const fadeUpAnimation = (element, delay = 0) => gsap.fromTo(element, {
            opacity: 0, y: 100, scale: 0.9,
        }, {
            duration: 1, opacity: 1, y: 0, scale: 1, delay: .5, ease: "power1.out",
        });

        const createScrollAnimation = (element, triggerStart, triggerEnd) => {
            gsap.fromTo(element, {
                opacity: 0, y: 50, scale: 0.9,
            }, {
                opacity: 1, y: 0, scale: 1, duration: .75,
                scrollTrigger: {
                    trigger: element,
                    start: triggerStart,
                    // end: triggerEnd,
                    scrub: false,
                    toggleActions: "play pause play reverse",
                    markers: false,
                }
            });
        };

        const fadeUpTextSectionHeading = block_animated_text.querySelector('.fade-up-text-section .heading');
        const fadeUpTextSectionDescription = block_animated_text.querySelector('.fade-up-text-section .description');

        const timeline = gsap.timeline();

        if (fadeUpTextSectionHeading) {
            timeline.add(fadeUpAnimation(fadeUpTextSectionHeading, .5));
        }
        if (fadeUpTextSectionDescription) {
            timeline.add(fadeUpAnimation(fadeUpTextSectionDescription), "-=0.6");
        }

        const scrollTextSections = block_animated_text.querySelectorAll('.scroll-text-section');

        scrollTextSections.forEach((section) => {
            const heading = section.querySelector('.heading');
            const description = section.querySelector('.description');

            if (heading) {
                createScrollAnimation(heading, "top 90%", "top center");
            }

            if (description) {
                createScrollAnimation(description, "top 90%", "top center");
            }
        });



    });
}

function commonBlockAnimations() {
    document.querySelectorAll('.block').forEach((block) => {
        block.querySelectorAll('.animated-element').forEach((element, index) => {
            gsap.fromTo(element, {
                opacity: 0, y: 50, scale: 0.9,
            }, {
                opacity: 1, y: 0, scale: 1, delay: index * 0.1,
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    // end: "bottom 20%",
                    scrub: false,
                    toggleActions: "play pause play reverse",
                    markers: false,
                }
            });
        });
    });
}

function initAcc002() {
    document.querySelectorAll('.block_acc002').forEach(block_acc002 => {

        const accordions = block_acc002.querySelectorAll('.accordion-button');
        const images = block_acc002.querySelectorAll('.accordion-image');
        let currentIndex = 0;
        let accordionTimer;
        const accordionDuration = 8000;

        // Function to set the container height to the largest image
        function setMaxHeight() {
            let maxHeight = 0;
            images.forEach(img => {
                const imgHeight = img.naturalHeight || img.height; // Get natural height if available
                if (imgHeight > maxHeight) {
                    maxHeight = imgHeight;
                }
            });

            // Set the height of the image-column to the max height
            block_acc002.querySelector('.image-column').style.height = `${maxHeight}px`;
        }

        // Initialize the max height on load
        setMaxHeight();

        // Initialize bootstrap collapse instances
        accordions.forEach(accordion => {
            new bootstrap.Collapse(document.querySelector(accordion.getAttribute('data-bs-target')), {
                toggle: false
            });
        });

        function createProgressBar(accordion) {
            const progressBar = document.createElement('div');
            progressBar.classList.add('progress-bar');
            let data_target = accordion.getAttribute('data-bs-target');
            block_acc002.querySelector(data_target).appendChild(progressBar);
            return progressBar;
        }

        function startProgress(accordion) {
            block_acc002.querySelectorAll('.progress-bar').forEach(t => t.remove());
            const progressBar = createProgressBar(accordion);
            gsap.fromTo(progressBar,
                { width: '0%' },
                {
                    width: '100%',
                    duration: accordionDuration / 1000,
                    ease: 'linear',
                    onComplete: () => {
                        progressBar.remove();
                    }
                }
            );
        }

        function toggleAccordion(index) {
            // Close all accordions
            accordions.forEach((accordion, i) => {
                const collapse = document.querySelector(accordion.getAttribute('data-bs-target'));
                if (collapse.classList.contains('show') && i !== index) {
                    bootstrap.Collapse.getInstance(collapse).hide();
                }
            });

            // Open current accordion
            const currentAccordion = accordions[index];
            const currentCollapse = document.querySelector(currentAccordion.getAttribute('data-bs-target'));
            if (!currentCollapse.classList.contains('show')) {
                bootstrap.Collapse.getInstance(currentCollapse).show();
            }
            startProgress(currentAccordion);
        }

        function switchAccordion() {
            hideImage(currentIndex);
            currentIndex = (currentIndex + 1) % accordions.length;
            toggleAccordion(currentIndex);
            showImage(currentIndex);
        }


        function resetCycle(startIndex) {
            clearInterval(accordionTimer);
            hideImage(currentIndex);
            currentIndex = startIndex;
            toggleAccordion(currentIndex);
            showImage(currentIndex);
            accordionTimer = setInterval(switchAccordion, accordionDuration);
        }

        function hideImage(index) {
            images[index].style.opacity = 0;
            images[index].classList.add('d-none');
        }

        function showImage(index) {
            images[index].classList.remove('d-none');
            gsap.to(images[index], { opacity: 1, duration: .5 });
        }

        accordions.forEach((accordion, index) => {
            accordion.addEventListener('click', () => {
                resetCycle(index);
            });
        });

        // Initialize ScrollTrigger
        ScrollTrigger.create({
            trigger: block_acc002,
            start: "top bottom",
            end: "bottom 35%",
            // markers: true,
            onEnter: () => {
                toggleAccordion(currentIndex);
                showImage(currentIndex);
                accordionTimer = setInterval(switchAccordion, accordionDuration);
            },
            onLeave: () => {
                clearInterval(accordionTimer);
            },
            onEnterBack: () => {
                toggleAccordion(currentIndex);
                showImage(currentIndex);
                accordionTimer = setInterval(switchAccordion, accordionDuration);
            },
            onLeaveBack: () => {
                clearInterval(accordionTimer);
            }
        });
    });
}

function initHr008() {

    document.querySelectorAll('.block_hr008').forEach(block_hr008 => {

        function blink(element) {
            gsap.fromTo(element, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: .75,
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut"
            });
        }

        const panels = block_hr008.querySelectorAll('.panel__section');
        const blink_elements = block_hr008.querySelectorAll('.blink');

        blink_elements.forEach(blink_element => {
            blink(blink_element);
        });

        panels.forEach((panel, i) => {
            ScrollTrigger.create({
                trigger: panel,
                start: "top 100%",
                end: "bottom 100%",
                snap: {
                    snapTo: 1,
                    duration: { min: 0.15, max: 0.25 },
                    ease: "power1.easeInOut"
                },
                scrub: 1,
                anticipatePin: 1,
                markers: false,
                onEnter: () => {
                    let heading = panel.querySelector('.heading');
                    gsap.fromTo(heading,
                        {
                            opacity: 0, scale: 0.7
                        },
                        {
                            opacity: 1, scale: 1, duration: 1.5, ease: "power1.easeInOut"
                        }
                    );
                },
            });
        });
    });
}

function initBul003() {

    document.querySelectorAll('.block_bul003').forEach(block_bul003 => {

        const icons = block_bul003.querySelectorAll('.icon-item .icon svg .animate-fill');
        const lines = block_bul003.querySelectorAll('.icon-item .icon .line');
        const items = block_bul003.querySelectorAll('.icon-item');

        // Create a GSAP timeline
        const tl = gsap.timeline({ paused: true }); // Paused initially

        icons.forEach((icon, index) => {
            // Animate the background color fill of the SVG using clip-path
            tl.fromTo(icon,
                {
                    clipPath: "inset(0% 0 100% 0)" // Starts from the top
                },
                {
                    clipPath: "inset(0% 0 0% 0)", // Ends at the bottom
                    duration: .75,
                    ease: "power1.inOut",
                    onUpdate: function () {
                        // To force the SVG repaint and make the clip-path apply correctly
                        icon.setAttribute('fill', '#FFFFFF');
                    }
                }
            );

            // Animate the connecting line to the next icon-item
            if (index < items.length - 1) {
                const nextItem = items[index + 1];
                const line = lines[index];
                const lineHeight = 20 + nextItem.getBoundingClientRect().top - icon.getBoundingClientRect().bottom;

                // Adjust the position of the line to grow from top to bottom
                line.style.top = '34px';
                line.style.bottom = 'auto';

                tl.fromTo(line,
                    {
                        height: 0
                    },
                    {
                        height: lineHeight + "px", // Grows downward
                        duration: .75,
                        ease: "power1.inOut"
                    },
                    //">-0.2" // Overlap this animation with the end of the previous animation
                );
            }
        });

        // Create an Intersection Observer
        const observerOptions = {
            threshold: 0.2 // 20% of the block must be visible
        };

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    tl.play(); // Play the timeline when 20% of the element is in the viewport
                    observer.unobserve(block_bul003); // Stop observing once animation has started
                }
            });
        }, observerOptions);

        // Observe the block_bul003 element
        observer.observe(block_bul003);
    });
}

function initSl007() {
    document.querySelectorAll('.block_sl007').forEach(block_sl007 => {

        let sections = gsap.utils.toArray(block_sl007.querySelectorAll(".panel"));
        let pin_wrapper = block_sl007.querySelector(".pin-wrapper");

        gsap.to(sections, {
            xPercent: -100 * (sections.length - 1),
            ease: "none",
            scrollTrigger: {
                trigger: pin_wrapper,
                start: "-110 top",
                pin: true,
                pinSpacing: true,
                scrub: 1,
                // snap: 1 / (sections.length - 1),
                end: "+=" + (sections.length * 100) + "%",
                anticipatePin: 1,
                markers: false,
            }
        });
    });
}

function initSL012() {

    document.querySelectorAll('.block_sl012').forEach(block_sl012 => {
        const markers = block_sl012.querySelectorAll(".contentMarker");
        const block_content = block_sl012.querySelector(".block-content");
        const left_content = block_sl012.querySelector(".left-content");

        // Hacer que solo la izquierda quede fija
        gsap.to(left_content, {
            scrollTrigger: {
                trigger: block_content,
                start: "top top",
                end: "bottom bottom",
                pin: left_content,
                pinSpacing: false,
                scrub: true,
            }
        });

        // Cambiar las imágenes según el desplazamiento del contenido
        markers.forEach((marker) => {
            ScrollTrigger.create({
                trigger: marker,
                start: "top center",
                end: "bottom center",
                onEnter: () => changeImage(marker),
                onEnterBack: () => changeImage(marker),
                markers: false,
            });
        });

        function changeImage(marker) {
            const imgId = marker.getAttribute("data-marker-content");
            const allImages = block_sl012.querySelectorAll(".imageToShow");

            allImages.forEach((img) => {
                if (img.id === imgId) {
                    img.style.opacity = 1;
                    img.style.visibility = "visible";
                } else {
                    img.style.opacity = 0;
                    img.style.visibility = "hidden";
                }
            });

            const activeImg = document.getElementById(imgId);
            activeImg.style.opacity = 1;
            activeImg.style.visibility = "visible";
        }

    });
}

function initSL013() {

    document.querySelectorAll('.block_sl013').forEach(block_sl013 => {
        const markers = block_sl013.querySelectorAll(".contentMarker");
        const block_content = block_sl013.querySelector(".block-content");
        const left_content = block_sl013.querySelector(".left-content");

        // Hacer que solo la izquierda quede fija
        gsap.to(left_content, {
            scrollTrigger: {
                trigger: block_sl013,
                start: "top top",
                end: "bottom bottom",
                pin: ".left-content",
                pinSpacing: false,
                scrub: true,
                markers: false,
            }
        });

        // Cambiar las imágenes según el desplazamiento del contenido
        markers.forEach((marker) => {
            ScrollTrigger.create({
                trigger: marker,
                start: "top center",
                end: "bottom center",
                onEnter: () => changeImage(marker),
                onEnterBack: () => changeImage(marker),
                markers: false,
            });
        });

        function changeImage(marker) {
            const imgId = marker.getAttribute("data-marker-content");
            const allImages = block_sl013.querySelectorAll(".imageToShow");

            allImages.forEach((img) => {
                if (img.id === imgId) {
                    img.style.opacity = 1;
                    img.style.visibility = "visible";
                } else {
                    img.style.opacity = 0;
                    img.style.visibility = "hidden";
                }
            });

            const activeImg = document.getElementById(imgId);
            activeImg.style.opacity = 1;
            activeImg.style.visibility = "visible";
        }

    });
}

function initSL016() {

    document.querySelectorAll('.block_sl016').forEach(block_sl016 => {
        const markers = block_sl016.querySelectorAll(".contentMarker");
        const block_content = block_sl016.querySelector(".block-content");
        const left_content = block_sl016.querySelector(".left-content");
        let img2Timeline; // Variable to store the timeline for img2 animations

        // Pin the left content as the page scrolls
        gsap.to(left_content, {
            scrollTrigger: {
                trigger: block_sl016,
                start: "top top",
                end: "bottom bottom",
                pin: left_content,
                pinSpacing: false,
                scrub: true,
                markers: false,
            }
        });

        // Create ScrollTriggers for each marker to change images on scroll
        markers.forEach((marker) => {
            ScrollTrigger.create({
                trigger: marker,
                start: "top center",
                end: "bottom center",
                onEnter: () => changeImage(marker),
                onEnterBack: () => changeImage(marker),
                markers: false,
            });
        });

        function changeImage(marker) {
            const imgId = marker.getAttribute("data-marker-content");
            const allImages = block_sl016.querySelectorAll(".imageToShow");
            const img2Elements = block_sl016.querySelectorAll(".img2");

            // Hide all images before showing the relevant one
            allImages.forEach((img) => {
                img.style.opacity = 0;
                img.style.visibility = "hidden";
            });

            // If a timeline exists, pause and kill it before creating a new one
            if (img2Timeline) {
                img2Timeline.pause();
                img2Timeline.kill();
            }

            // If the content relates to img2, create a timeline for staggered fade-in
            if (imgId.includes("img2")) {
                img2Timeline = gsap.timeline();

                img2Elements.forEach((img, index) => {
                    if (index === 0) {
                        // Show the first image immediately
                        img2Timeline.to(img, {
                            opacity: 1,
                            visibility: "visible",
                            delay: 0,
                        });
                    } else {
                        // Stagger the fade-in effect for subsequent img2 elements
                        img2Timeline.to(img, {
                            opacity: 1,
                            visibility: "visible",
                            delay: 0.25, // Stagger delay for subsequent images
                            duration: 0.25, // Fade-in duration
                        });
                    }
                });
            } else {
                // For non-img2 images, show the active image directly
                const activeImg = document.getElementById(imgId);
                if (activeImg) {
                    gsap.to(activeImg, {
                        opacity: 1,
                        visibility: "visible",
                    });
                }
            }
        }
    });
}

function initSL019() {

    document.querySelectorAll('.block_sl019').forEach(block_sl019 => {
        const markers = block_sl019.querySelectorAll(".contentMarker");
        const block_content = block_sl019.querySelector(".block-content");
        const left_content = block_sl019.querySelector(".left-content");

        // Hacer que solo la izquierda quede fija
        gsap.to(left_content, {
            scrollTrigger: {
                trigger: block_content,
                start: "top top",
                end: "bottom bottom",
                pin: left_content,
                pinSpacing: false,
                scrub: true,
            }
        });

        // Cambiar las imágenes según el desplazamiento del contenido
        markers.forEach((marker) => {
            ScrollTrigger.create({
                trigger: marker,
                start: "top center",
                end: "bottom center",
                onEnter: () => changeImage(marker),
                onEnterBack: () => changeImage(marker),
                markers: false,
            });
        });

        function changeImage(marker) {
            const imgId = marker.getAttribute("data-marker-content");
            const allImages = block_sl019.querySelectorAll(".imageToShow");

            allImages.forEach((img) => {
                if (img.id === imgId) {
                    img.style.opacity = 1;
                    img.style.visibility = "visible";
                } else {
                    img.style.opacity = 0;
                    img.style.visibility = "hidden";
                }
            });

            const activeImg = document.getElementById(imgId);
            activeImg.style.opacity = 1;
            activeImg.style.visibility = "visible";
        }

    });
}

function initPar001() {
    document.querySelectorAll('.block_par001').forEach(block_par001 => {

        const headphones = block_par001.querySelector('.headphones');
        const mouse = block_par001.querySelector('.mouse');
        const computer = block_par001.querySelector('.computer');
        const phone = block_par001.querySelector('.phone');
        const tablet = block_par001.querySelector('.tablet');
        const messy_cables = block_par001.querySelector('.messy-cables');

        const parallax = gsap.timeline({
            scrollTrigger: {
                trigger: block_par001,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                markers: false,
            }
        });

        parallax.to(headphones, {
            yPercent: 500,
            ease: "none",
        });

        parallax.to(mouse, {
            yPercent: 100,
            ease: "none",
        }, 0);

        parallax.to(computer, {
            yPercent: -60,
            ease: "none",
        }, 0);

        parallax.to(phone, {
            yPercent: 75,
            ease: "none",
        }, 0);

        parallax.to(tablet, {
            yPercent: -40,
            ease: "none",
        }, 0);


        const parallax_cable = gsap.timeline({
            scrollTrigger: {
                trigger: messy_cables,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                markers: false,
            }
        });

        parallax_cable.fromTo(messy_cables, {
            yPercent: 10,
        }, {
            yPercent: -5,
        }, 0);
    });
}

function initBtn001() {
    document.querySelectorAll('.block_btn001').forEach(block_btn001 => {
        const buttons = block_btn001.querySelectorAll('.btn');
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block_btn001,
                start: "top bottom",
                toggleActions: "play reverse play reverse",
                markers: false,
            }
        });

        tl.fromTo(buttons, {
            y: 50,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.3,
        });
    });
}

function initCol003() {
    document.querySelectorAll('.block_col003').forEach(block_col003 => {
        ScrollTrigger.create({
            trigger: block_col003,
            start: "top center",
            onEnter: () => playVideo(),
            onEnterBack: () => playVideo(),
        });

        function playVideo() {
            const video = block_col003.querySelector('.customer-video');
            if (video && typeof video.play === 'function') {
                video.play().catch(error => {
                    console.error('Error attempting to play video:', error);
                });
            } else {
                console.error('Video element not found or play function is not available.');
            }
        }
    });
}

function initIndi003() {
    if (window.innerWidth > 991) {
        document.querySelectorAll('.block_indi003').forEach(block_indi003 => {
            let colored_map = block_indi003.querySelector('.colored-map');
            gsap.to(colored_map, {
                duration: 1,
                opacity: 1,
                ease: 'power1.inOut',
                scrollTrigger: {
                    trigger: colored_map,
                    start: "top center",
                    end: "bottom center",
                    toggleActions: "play pause play reverse",
                },
            });
        });
    }
}

function initQuot005() {
    document.querySelectorAll('.block_quot005').forEach(block_quot005 => {
        ScrollTrigger.create({
            trigger: block_quot005,
            start: "top center",
            onEnter: () => playVideo(),
            onEnterBack: () => playVideo(),
        });

        function playVideo() {
            const video = block_quot005.querySelector('.customer-video');
            if (video && typeof video.play === 'function') {
                video.play().catch(error => {
                    console.error('Error attempting to play video:', error);
                });
            } else {
                console.error('Video element not found or play function is not available.');
            }
        }
    });
}

function initVid002() {
    document.querySelectorAll('.block_vid002').forEach(block_vid002 => {
        ScrollTrigger.create({
            trigger: block_vid002,
            start: "top center",
            onEnter: () => playVideo(),
            onEnterBack: () => playVideo(),
        });

        function playVideo() {
            const video = block_vid002.querySelector('.customer-video');
            if (video && typeof video.play === 'function') {
                video.play().catch(error => {
                    console.error('Error attempting to play video:', error);
                });
            } else {
                console.error('Video element not found or play function is not available.');
            }
        }
    });
}

function handleResize() {
    initIndi003();
}

function init() {
    initSmoothScrollLenis();
    init_mega_menu();
    initSwipers();
    scroll_heading_animation();
    commonBlockAnimations();
    initAcc002();
    initHr008();
    initCol003();
    initBul003();
    initSl007();
    initPar001();
    initBtn001();
    initIndi003();
    initSL012();
    initSL013();
    initSL016();
    initSL019();
    initQuot005();
    initVid002();
    handleResize();
    window.addEventListener('resize', handleResize);
}

document.addEventListener('DOMContentLoaded', function () {
    init();
});
